/* Component wrapper for the GoogleMapsSupport object defined in
 * app/views/layouts/partials/_google_maps.html.erb
 */

const GoogleMapsService = {
  onReady(callback) {
    if (typeof window.GoogleMapsSupport === 'undefined') {
      console.error('Google Maps support not loaded');
      return;
    }
    window.GoogleMapsSupport.addListener(callback);
  },
};

export default GoogleMapsService;
